if (!customElements.get('mobile-menu')) {
    class MobileMenu extends HTMLElement {
        constructor() {
            super();
            this.header = this.closest('header');
            this.preventToggle = false;
            this.mobileToggler = this.header.querySelector('[data-mobile-toggler]');
            if (this.mobileToggler) {
                this.mobileToggler.addEventListener('click', this.toggleMobileMenu.bind(this));
            }
            window.addEventListener('resize', this.handleResize.bind(this));
            // Array.from(this.querySelectorAll('[data-menu-item]'), (element) => {
            // element.addEventListener('click', (event) => {
            // if (!this.preventToggle) {
            // this.openMenus(element);
            // }
            // });
            // });

            // Array.from(this.querySelectorAll('[data-back-to-menu]'), (item) => {
            // item.addEventListener('click', (event) => {
            // this.backToMenu(item);
            // this.preventToggle = true;
            // setTimeout(() => {
            // this.preventToggle = false;
            // }, 100);
            // });
            // });
        }

        handleResize() {
            if (window.innerWidth > 1024 && document.querySelector(`[data-drawer="mobile-menu-drawer"]`).classList.contains('open')) {
                document.querySelector(`[data-drawer="mobile-menu-drawer"]`).classList.remove('open');
                document.body.classList.remove('overflow-hidden');
            }
        }
        // openMenus(element) {
        // element.classList.add('active');
        // }

        // backToMenu(item) {
        // const parentMenuItem = item.closest('[data-menu-item]');
        // if (parentMenuItem) {
        // parentMenuItem.classList.remove('active');
        // } else {
        // console.info('Parent menu item not found.');
        // }
        // }

        toggleMobileMenu() {
            if (document.querySelector(`[data-drawer="mobile-menu-drawer"]`)) {
                setTimeout(() => {
                    document.querySelector(`[data-drawer="mobile-menu-drawer"]`).classList.add('open');
                    document.body.classList.add('overflow-hidden');
                }, 200);
                setTimeout(() => {
                    document.querySelector(`[data-drawer="mobile-menu-drawer"] button`).focus();
                    trapFocus(document.querySelector(`[data-drawer="mobile-menu-drawer"]`));
                }, 300);
            }
        }
    }
    customElements.define('mobile-menu', MobileMenu);
}

if (!customElements.get('hamburger-menu-drawer')) {
    class hamburgerMenuDrawer extends HTMLElement {
        constructor() {
            super();

            this.headerSectionMain = document.querySelector('[data-header-section]');

            this.header = this.closest('header');
            this.preventToggle = false;
            this.isKeyboardNav = !1;
            this.updateHeaderHeight();
            this.querySelectorAll('[data-menu-item]').forEach((element) => {
                element.addEventListener('click', (event) => {
                    this.isKeyboardNav = !1;
                    if (!this.preventToggle) {
                        this.openMenus(element);
                    }
                });
                element.addEventListener('keydown', (event) => {
                    this.isKeyboardNav = !0;
                    if (event.key === 'Enter' || event.key === ' ') {
                        if (event.target.tagName === 'A' && event.target.hasAttribute('href') && event.target.getAttribute('href') !== '#') {
                            return;
                        } else {
                            event.preventDefault();
                            if (!this.preventToggle) {
                                this.openMenus(element);
                            }
                        }
                    }
                });
            });
            this.querySelectorAll('[data-back-to-menu]').forEach((item) => {
                item.addEventListener('click', (event) => {
                    this.isKeyboardNav = !1;
                    this.backToMenu(item);
                    this.preventToggle = true;
                    setTimeout(() => {
                        this.preventToggle = false;
                    }, 100);
                });
                item.addEventListener('keydown', (event) => {
                    this.isKeyboardNav = !0;
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        this.backToMenu(item);
                        this.preventToggle = true;
                        setTimeout(() => {
                            this.preventToggle = false;
                        }, 100);
                    }
                });
            });

            this.querySelectorAll('[data-grandchild-child-trigger]').forEach((item) => {
                item.addEventListener('click', (event) => {
                    this.isKeyboardNav = !1;
                    this.grandChild(item);
                });
                item.addEventListener('keydown', (event) => {
                    this.isKeyboardNav = !0;
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        this.grandChild(item);
                    }
                });
            });
        }

        grandChild(item) {
            const grandchildparentMenuItem = item.closest('[data-grandchild-child]');
            if (grandchildparentMenuItem) {
                grandchildparentMenuItem.classList.toggle('active');
            }
        }

        openMenus(element) {
            element.classList.add('active');
            element.addEventListener("focusout", (event) => this.onFocusOut(event, element));
        }

        onFocusOut(event, element) {
            // Delay to allow focus to possibly move within the element
            this.isKeyboardNav && setTimeout(() => {
                if (!element.contains(document.activeElement)) {
                    element.classList.remove('active');
                }
            }, 50);
        }

        backToMenu(item) {
            const parentMenuItem = item.closest('[data-menu-item]');
            if (parentMenuItem) {
                parentMenuItem.classList.remove('active');
            }
        }

        updateHeaderHeight() {
            this.announcementbarHeight = document.querySelector('.announcement-section')?.getBoundingClientRect().height.toFixed(2) || 0;
            this.headerHeight = document.querySelector('[data-header-section]')?.getBoundingClientRect().height.toFixed(2) || 0;
            document.body.style.setProperty('--announcement-height', `${this.announcementbarHeight
                }px`);
            document.body.style.setProperty('--dynamic-announcement-height', `${this.announcementbarHeight
                }px`);
            document.body.style.setProperty('--header-height', `${this.headerHeight
                }px`);
            if (window.innerWidth >= 1024 && this.headerSectionMain?.classList.contains('header-style-side-reveal-menu')) {
                document.body.style.setProperty('--dynamic-header-height', `${this.headerHeight
                    }px`);
            } else {
                document.body.style.removeProperty('--dynamic-header-height', '0px');
            }
        }
    }
    customElements.define('hamburger-menu-drawer', hamburgerMenuDrawer);
}

if (!customElements.get('sticky-on-scroll')) {
    class StickyOnScroll extends HTMLElement {
        constructor() {
            super();
            this.currentScrollTop = 0;
            window.addEventListener('scroll', this.onScroll.bind(this), false);
            const resizeObserver = new ResizeObserver(this.onScroll.bind(this));
            resizeObserver.observe(this);
            this.splitCollapsemenus = this.querySelector('div[is="split-collapse-menus"]');
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            this.headerHeight = this?.getBoundingClientRect().height.toFixed(2);
            const header = this.closest('header');

            if (scrollTop > 300) {
                if (scrollTop > this.currentScrollTop) {
                    this.classList.add('is-hidden');
                    header.classList.add('is-hidden-header');
                    this.classList.remove('is-sticky');
                    document.body.classList.remove('header-sticky');
                    document.body.style.setProperty('--dynamic-header-height', `0px`);

                    // Dispatch event when sticky class is removed
                    document.dispatchEvent(new CustomEvent('headerStickyState', {
                        detail: {
                            enabled: false
                        }
                    }));
                } else {
                    this.classList.add('is-sticky');
                    this.classList.remove('is-hidden');
                    header.classList.remove('is-hidden-header');
                    // this.classList.add('is-sticky');
                    document.body.classList.add('header-sticky');
                    document.body.style.setProperty('--dynamic-header-height', `${this.headerHeight
                        }px`);
                    // Dispatch event when sticky class is added
                    document.dispatchEvent(new CustomEvent('headerStickyState', {
                        detail: {
                            enabled: true
                        }
                    }));
                }
            } else {
                this.classList.remove('is-hidden', 'is-sticky');
                header.classList.remove('is-hidden-header');
                // this.classList.remove('is-sticky');
                document.body.style.setProperty('--dynamic-header-height', `${this.headerHeight
                    }px`);

                // Dispatch event when sticky class is removed
                document.dispatchEvent(new CustomEvent('headerStickyState', {
                    detail: {
                        enabled: false
                    }
                }));
                this.splitCollapsemenus?.hideMenu();
            }
            this.currentScrollTop = scrollTop;
        }
    }
    customElements.define('sticky-on-scroll', StickyOnScroll);
}

if (!customElements.get('sticky-always')) {
    class StickyAlways extends HTMLElement {
        constructor() {
            super();
            this.currentScrollTop = 0;
            window.addEventListener('scroll', this.onScroll.bind(this), false);
            this.headerElement();
            this.splitCollapsemenus = this.querySelector('div[is="split-collapse-menus"]');
        }

        onScroll() {
            this.headerHeight = this?.getBoundingClientRect().height;
            document.body.style.setProperty('--dynamic-header-height', `${this.headerHeight
                }px`);
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > 100) {
                if (this.classList.contains('is-sticky')) return;
                this.classList.add('is-sticky');
                document.dispatchEvent(new CustomEvent('headerStickyState', {
                    detail: {
                        enabled: true
                    }
                }));
            } else {
                this.classList.remove('is-sticky');
                document.dispatchEvent(new CustomEvent('headerStickyState', {
                    detail: {
                        enabled: false
                    }
                }));
                this.splitCollapsemenus?.hideMenu();
            }
        }

        headerElement() {
            this.headerHeight = this?.getBoundingClientRect().height;
            document.dispatchEvent(new CustomEvent('headerStickyState', {
                detail: {
                    enabled: false
                }
            }));
            document.body.style.setProperty('--dynamic-header-height', `${this.headerHeight
                }px`);
        }
    }
    customElements.define('sticky-always', StickyAlways);
}

if (!customElements.get('header-menu')) {
    class HeaderMenu extends HTMLElement {
        constructor() {
            super();
            this.headerNavigation = this.closest('[data-header-navigation]');
            this.menuItem = this.closest('.header-menu-item');
            this.subMenu = this.querySelector('[header-menu-inner]');
            // this.subMenuDropdownClick = this.querySelectorAll('[data-menu-dropdown-click]');
            this.subMenuDropdownHover = this.querySelectorAll('[data-menu-dropdown-hover]');
            this.subMenuDropdown = this.querySelectorAll('[data-submenu-dropdown]');
            this.blockMegamenuitems = this.querySelectorAll('[data-submenu-index]');
            this.grandchildChild = this.querySelectorAll('[data-grandchild-child]');
            this.shopifySection = this.closest('.shopify-section');
            this.header = this.shopifySection?.querySelector('header');
            this.blockMegamenuitems.forEach((blockMegaMenuItem) => {
                blockMegaMenuItem.addEventListener('click', this.blockMegamenu.bind(this));
            });
            this.querySelectorAll('[mega-menu-submenu]').forEach((submenuItem) => submenuItem.addEventListener('mouseenter', this.initializeSubmenu.bind(this, submenuItem)));
            // this.subMenuDropdownClick.forEach((submenuItemDropdown) => {
            // submenuItemDropdown.addEventListener('click', this.openDropdown.bind(this));
            // submenuItemDropdown.addEventListener('keydown', (event) => {
            // if (event.key === 'Enter') {
            // event.preventDefault();
            // event.stopPropagation();
            // this.openDropdown(event);
            // }
            // });
            // });
            this.subMenuDropdownHover.forEach((submenuItemDropdown) => {
                submenuItemDropdown.addEventListener('mouseenter', this.openDropdown.bind(this));
            });
            this.grandchildChild.forEach((grandChildDropdown) => {
                grandChildDropdown.addEventListener('click', this.opengrandChild.bind(this));
                grandChildDropdown.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        this.opengrandChild(event);
                    }
                });
            });

            this.menuItem.addEventListener('keyup', this.onEscapeKey.bind(this));
            this.hideTimeout = null;
            this.addEventListener('keydown', (event) => {
                const target = event.target;
                if (event.target.classList.contains('header-menu-link')) {
                    if (event.key === 'Enter') {
                        // if ( target.tagName === 'A' && target.hasAttribute('href') && target.getAttribute('href') !== '#') { 
                        //   return;
                        // }else{
                        event.preventDefault();
                        this.toggleContent(event);
                        // }
                    }
                }
            });
            this.addEventListener('focusout', this.handleFocusOut.bind(this));
            if (this.dataset.headerNavigation == 'hover') {
                this.addEventListener('mouseenter', this.showMenu.bind(this));
                this.addEventListener('mouseleave', this.delayedHideMenu.bind(this));
                // this.addEventListener('keydown', (event) => {
                // if (event.key === 'Enter') {
                // event.preventDefault();
                // this.toggleContent();
                // }
                // });
            } else {
                this.addEventListener('click', this.toggleContent.bind(this));
            }
            this.initHeader();
            this.dropDownMenuPositions();
            this.addScrollListener();
            this.offsetForDropDown();
            this.resizeObserver = new ResizeObserver(this.dropDownMenuPositions.bind(this));
            this.resizeObserver.observe(this.shopifySection);
            const resizeObserverDropdown = new ResizeObserver(this.offsetForDropDown.bind(this));
            resizeObserverDropdown.observe(this.closest('[data-header-section]'));
        }

        handleFocusOut(event) {
            setTimeout(() => {
                const focusedElement = document.activeElement;
                if (!this.contains(focusedElement)) {
                    this.deactivateAllMenus();
                }
            }, 0);
        }

        connectedCallback() {
            if (this.shopifySection) {
                this.resizeObserver = new ResizeObserver(this.updateHeaderHeight.bind(this));
                this.resizeObserver.observe(this.shopifySection);
            }
            document.body.addEventListener('click', this.handleClickOutside.bind(this));
            this.subMenu?.addEventListener('click', this.stopPropagation);
        }

        disconnectedCallback() {
            if (this.shopifySection) {
                this.resizeObserver.unobserve(this.shopifySection);
            }
            document.removeEventListener('click', this.handleClickOutside.bind(this));
        }
        blockMegamenu(event) {
            event.preventDefault();
            const parentMenu = event.currentTarget.closest('[data-block-mega-menu-parents]');
            if (!parentMenu) return;
            const submenuIndex = event.currentTarget.getAttribute('data-submenu-index');
            const submenuItems = parentMenu.querySelectorAll('[data-submenu-index]');
            const headerBlockSubmenus = parentMenu.querySelectorAll('[header-block-submenu]');
            submenuItems.forEach((submenuItem) => {
                submenuItem.classList.remove('active');
            });
            headerBlockSubmenus.forEach((headerBlock) => {
                headerBlock.classList.remove('active');
            });
            const targetSubmenu = parentMenu.querySelector(`.${submenuIndex}`);
            if (targetSubmenu) {
                targetSubmenu.classList.add('active');
            }
            event.currentTarget.classList.add('active');
        }

        offsetForDropDown() {
            const submenu = this.querySelector('[header-menu-inner]');
            if (submenu && this.classList.contains('header-dropdown')) {
                const container = this.closest('ul[is="menu-slide"]');
                if (!container) {
                    return;
                }
                const containerRect = container.getBoundingClientRect();
                const menuRect = this.getBoundingClientRect();
                const submenuRect = submenu.getBoundingClientRect();
                const gap = 0;
                let offsetLeft = menuRect.left - containerRect.left;
                const maxOffsetLeft = containerRect.width - submenuRect.width - gap;
                if (offsetLeft + submenuRect.width > containerRect.width - gap) {
                    offsetLeft = maxOffsetLeft;
                }
                offsetLeft = Math.max(offsetLeft, gap);
                submenu.closest('.split-menus-header-dropdown-wrapper').style.left = `${offsetLeft}px`;
            }
        }

        opengrandChild(event) {
            event.preventDefault();
            const parentMenu = event.currentTarget.closest('[data-grandchild-child-parent]');
            if (!parentMenu) return;
            const targetSubmenu = parentMenu.querySelector('[data-grandchild-child-content]');
            if (targetSubmenu) {
                targetSubmenu.classList.toggle('active');
            }
            event.currentTarget.classList.toggle('active');
        }
        openDropdown(event) {
            event.preventDefault();
            this.subMenuDropdown.forEach((submenu) => {
                if (submenu != event.currentTarget) {
                    submenu.classList.remove('submenu-dropdown-active');
                }
            });
            event.currentTarget.classList.toggle('submenu-dropdown-active');
        }

        initHeader() {
            if (this.header) { // this.shopifySection.classList.add('sticky-active');
                this.updateHeaderHeight();
            }
        }

        addScrollListener() {
            window.addEventListener('scroll', this.handleScroll.bind(this));
        }

        toggleContent(e) {
            e.preventDefault();
            this.classList.contains('active')
                ? this.deactivateAllMenus()
                : this.showMenu();
        }

        handleScroll() {
            if (!this.stickyHeader) return;
            const scrollY = window.scrollY;
            const isScrollingDown = this.windowScrollTop < scrollY;
            this.shopifySection.classList.toggle('is-sticky', scrollY > this.headerHeight);
            document.body.style.setProperty(
                '--header-height',
                this.shopifySection.classList.contains('is-hidden')
                    ? '0px'
                    : `${this.headerHeight
                    }px`
            );
            this.windowScrollTop = scrollY;
        }

        updateHeaderHeight() {
            this.announcementbarHeight = document.querySelector('.announcement-section')?.getBoundingClientRect().height.toFixed(2) || 0;
            this.headerHeight = this.shopifySection.querySelector('[data-header-section]')?.getBoundingClientRect().height.toFixed(2) || 0;
            document.body.style.setProperty('--announcement-height', `${this.announcementbarHeight
                }px`);
            document.body.style.setProperty('--header-height', `${this.headerHeight
                }px`);
        }

        onEscapeKey(event) {
            if (event.code.toUpperCase() !== 'ESCAPE') return;
            if (event.currentTarget.classList.contains('active')) {
                this.deactivateAllMenus();
            }
        }

        handleClickOutside(event) {
            if (this.contains(event.target)) {
                return;
            } else {
                this.deactivateAllMenus();
            }
        }

        deactivateAllMenus() {
            document.querySelectorAll('header-menu.active').forEach((activeMenu) => {
                activeMenu.classList.remove('active');
                activeMenu.closest('.header-menu-item')?.classList.remove('active');
                if (activeMenu.querySelector('[data-block-mega-menu-parents]') && !(activeMenu.querySelector('[data-block-mega-menu-parents]').hasAttribute('inert'))) {
                    activeMenu.querySelector('[data-block-mega-menu-parents]').setAttribute('inert', '');
                }
            });
            if (!document.querySelector('header-menu.active') && document.body.classList.contains('megamenu-open')) {
                document.body.classList.remove('megamenu-open', 'body-overlay');
                // document.body.classList.remove('body-overlay');
            }
        }

        initializeSubmenu(submenuItem) {
            const headerMenu = submenuItem.closest('header-menu');
            headerMenu.querySelectorAll('[mega-menu-submenu]').forEach((submenu) => {
                submenu.classList.remove('mega-menu-submenu-active');
            });
            headerMenu.querySelectorAll('[mega-menu-grandchild]').forEach((grandchild) => {
                grandchild.classList.remove('mega-menu-childlink-active');
            });
            submenuItem.classList.add('mega-menu-submenu-active');
        }

        showMenu() {
            clearTimeout(this.hideTimeout);
            this.deactivateAllMenus();
            setTimeout(() => {
                if (this.classList.contains('header-megamenu') || this.classList.contains('header-dropdown')) {
                    document.body.classList.add('megamenu-open', 'body-overlay');
                    // document.body.classList.add('body-overlay');
                } if (this.menuItem.classList.contains('has-children')) {
                    this.menuItem.classList.add('active');
                    this.classList.add('active');
                    if (this.querySelector('[data-block-mega-menu-parents]') && this.querySelector('[data-block-mega-menu-parents]').hasAttribute('inert')) {
                        this.querySelector('[data-block-mega-menu-parents]').removeAttribute('inert');
                    }
                }
            }, 100);
        }

        hideMenu() {
            this.classList.remove('active');
            this.menuItem.classList.remove('active');
            if (!document.querySelector('header-menu.active')) {
                document.body.classList.remove('megamenu-open', 'body-overlay');
                // document.body.classList.remove('body-overlay');
            }
            // this.subMenuDropdownClick.forEach((submenuItemDropdown) => {
            // submenuItemDropdown.classList.remove('submenu-dropdown-active');
            // });
        }

        dropDownMenuPositions() {
            // if (window.innerWidth < 992) return false;
            this.querySelector('[header-menu-inner]').classList.remove("menu-position-left");
            const windowSize = window.innerWidth - 200;
            const rect = this.getBoundingClientRect();
            let currentPosition = rect.left + rect.width;
            const grandChildList = this.querySelector("[header-menu-inner]");
            if (grandChildList) {
                currentPosition += grandChildList.getBoundingClientRect().width;
            }
            if (currentPosition >= windowSize) {
                this.querySelector('[header-menu-inner]').classList.add("menu-position-left");
            }
        }

        delayedHideMenu() {
            this.hideTimeout = setTimeout(this.hideMenu.bind(this), 100);
        }

        stopPropagation(event) {
            event.stopPropagation();
        }
    }
    customElements.define('header-menu', HeaderMenu);
}
if (!customElements.get('menu-slide')) {
    class MenuSlide extends HTMLUListElement {
        constructor() {
            super();
            this.scrollStep = 40;
            this.container = null;
            this.leftArrow = null;
            this.rightArrow = null;
        }
        connectedCallback() {
            this.container = this.closest('nav');
            this.leftArrow = this.container.querySelector('[data-arrow-left]');
            this.rightArrow = this.container.querySelector('[data-arrow-right]');

            this.leftArrow.addEventListener('click', this.scrollLeftFun.bind(this));
            this.rightArrow.addEventListener('click', this.scrollRightFun.bind(this));

            window.addEventListener('resize', this.updateArrows.bind(this));
            this.updateArrows();
            this.callOffsetForDropDown();
        }

        scrollLeftFun() {
            this.scrollBy({
                left: -this.scrollStep,
                behavior: 'smooth'
            });
            this.updateArrowsImmediate(-this.scrollStep);
            this.callOffsetForDropDown();
        }

        scrollRightFun() {
            const maxScrollLeft = this.scrollWidth - this.clientWidth;
            this.scrollBy({ left: this.scrollStep, behavior: 'smooth' });
            this.updateArrowsImmediate(this.scrollStep);
            this.callOffsetForDropDown();
        }

        updateArrows() {
            const maxScrollLeft = this.scrollWidth - this.clientWidth;

            this.leftArrow.style.display = this.scrollLeft === 0
                ? 'none'
                : 'flex';
            this.rightArrow.style.display = this.scrollLeft >= maxScrollLeft
                ? 'none'
                : 'flex';
        }

        updateArrowsImmediate(scrollChange) {
            const maxScrollLeft = this.scrollWidth - this.clientWidth;
            const newScrollLeft = Math.max(0, Math.min(this.scrollLeft + scrollChange, maxScrollLeft));
            this.leftArrow.style.display = newScrollLeft === 0
                ? 'none'
                : 'flex';
            this.rightArrow.style.display = newScrollLeft >= maxScrollLeft
                ? 'none'
                : 'flex';
        }

        callOffsetForDropDown() {
            const headerMenus = this.querySelectorAll('li header-menu');
            headerMenus.forEach(headerMenu => {
                if (headerMenu.offsetForDropDown) {
                    headerMenu.offsetForDropDown();
                }
            });
        }

    }
    customElements.define('menu-slide', MenuSlide, { extends: 'ul' });
}

if (!customElements.get('split-collapse-menus')) {
    class SplitCollapseMenus extends HTMLDivElement {
        constructor() {
            super();
            this.parentWrapper = this.closest('.split-header-collapse-menus-enable');
            this.menuSlide = this.querySelector('ul[is="menu-slide"]');
            this.headerMenus = this.menuSlide?.querySelectorAll('li header-menu');
            this.toggleButton = this.querySelector('.collapse-menus-button');
            this.isSticky = false;
        }

        connectedCallback() {
            this.handleHeaderSticky();
            this.addEventListener('mouseenter', this.extendMenu);
            this.addEventListener('mouseleave', this.hideMenu);

            document.addEventListener('headerStickyState', (event) => {
                this.isSticky = event.detail.enabled;
                this.handleHeaderSticky();
            });

            if (this.toggleButton) {
                this.toggleButton.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        this.extendMenu();
                    }
                });
            }
        }

        disconnectedCallback() {
            this.removeEventListener('mouseenter', this.extendMenu);
            this.removeEventListener('mouseleave', this.hideMenu);
        }

        handleHeaderSticky() {
            if (this.isSticky) {
                this.removeEventListener('mouseenter', this.extendMenu);
                this.removeEventListener('mouseleave', this.hideMenu);
                this.extendMenu();
            } else {
                this.addEventListener('mouseenter', this.extendMenu);
                this.addEventListener('mouseleave', this.hideMenu);
            }
        }

        extendMenu = () => {
            if (!this.isSticky && this.parentWrapper?.classList.contains('open-collapse-menus')) return;
            const left_arrow = this.querySelector('[data-arrow-left]');
            if (left_arrow)
                left_arrow.style.display = 'none';

            const right_arrow = this.querySelector('[data-arrow-right]');
            if (right_arrow)
                right_arrow.style.display = 'none';

            this.parentWrapper?.classList.add('stop-events-mega-menu', 'open-collapse-menus');
            setTimeout(() => {
                this.parentWrapper?.classList.remove('stop-events-mega-menu');
                this.menuSlide?.updateArrows();
                if (this.headerMenus) {
                    this.headerMenus.forEach(headerMenu => {
                        if (headerMenu.offsetForDropDown) {
                            headerMenu.offsetForDropDown();
                        }
                        if (headerMenu.dropDownMenuPositions) {
                            headerMenu.dropDownMenuPositions();
                        }
                    });
                }
            }, 1000);
        }

        hideMenu = () => {
            if (this.isSticky) return;
            this.parentWrapper?.classList.remove('open-collapse-menus', 'stop-events-mega-menu');
        }
    }
    customElements.define('split-collapse-menus', SplitCollapseMenus, { extends: 'div' });
}